/* eslint-disable semi */

/**
 * 前ゼロ
 * @param {*} value
 */
function _zero (value, dig = 0) {
  let result = String(value);
  result = '00000000' + result;
  return result.substr(dig * -1);
}

/**
 * 前ゼロ8桁
 * @param {*} value
 */
export function zero8 (value) {
  return _zero(value, 8);
};



// WEBPACK FOOTER //
// ./src/app/filters/zero.js